<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="医生名称" prop="doctorName">
                <a-input v-model="queryParam.doctorName" placeholder="请输入医生名称" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="变动类型" prop="changeType">
                <a-select placeholder="请选择变动类型" v-model="queryParam.changeType" style="width: 100%" allow-clear>
                  <a-select-option v-for="(d, index) in dict.type.change_type" :key="index" :value="d.value">{{ d.label }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="变动场景" prop="changeScene">
                <a-select placeholder="请选择变动场景" v-model="queryParam.changeScene" style="width: 100%" allow-clear>
                  <a-select-option v-for="(d, index) in dict.type.doctor_change_scene" :key="index" :value="d.value">{{ d.label }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="创建时间">
                <a-range-picker style="width: 100%" v-model="daterangeCreateTime" valueFormat="YYYY-MM-DD" format="YYYY-MM-DD" allow-clear/>
              </a-form-item>
            </a-col>
<!--            <template v-if="advanced">-->

<!--            </template>-->
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
<!--                  {{ advanced ? '收起' : '展开' }}-->
<!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
<!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
<!--        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['doctor:doctorScoreRrecord:add']">-->
<!--          <a-icon type="plus" />新增-->
<!--        </a-button>-->
<!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['doctor:doctorScoreRrecord:edit']">-->
<!--          <a-icon type="edit" />修改-->
<!--        </a-button>-->
<!--        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['doctor:doctorScoreRrecord:remove']">-->
<!--          <a-icon type="delete" />删除-->
<!--        </a-button>-->
        <a-button type="primary" @click="handleExport" v-hasPermi="['doctor:doctorScoreRrecord:export']">
          <a-icon type="download" />导出
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        :changeTypeOptions="dict.type.change_type"
        :changeSceneOptions="dict.type.doctor_change_scene"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="changeType" slot-scope="text, record">
          <dict-tag :options="dict.type['change_type']" :value="record.changeType"/>
        </span>
        <span slot="changeScene" slot-scope="text, record">
          <dict-tag :options="dict.type['doctor_change_scene']" :value="record.changeScene"/>
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="updateTime" slot-scope="text, record">
          {{ parseTime(record.updateTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['doctor:doctorScoreRrecord:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['doctor:doctorScoreRrecord:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['doctor:doctorScoreRrecord:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['doctor:doctorScoreRrecord:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageDoctorScoreRrecord,listDoctorScoreRrecord, delDoctorScoreRrecord } from '@/api/doctor/doctorScoreRrecord'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'DoctorScoreRrecord',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  dicts: ['change_type', 'doctor_change_scene'],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 版本号时间范围
      daterangeCreateTime: [],
      // 查询参数
      queryParam: {
        id: null,
        doctorName: null,
        changeType: null,
        beforeScore: null,
        score: null,
        afterScore: null,
        changeScene: null,
        creator: null,
        modifier: null,
        createTime: null,
        updateTime: null,
        isDeleted: null,
        remark: null,
        version: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '医生名称',
          dataIndex: 'doctorName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '变动场景',
          dataIndex: 'changeSceneStr',
          // scopedSlots: { customRender: 'changeScene' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '变动类型',
          dataIndex: 'changeTypeStr',
          // scopedSlots: { customRender: 'changeType' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '变动前华歧系数',
          dataIndex: 'beforeScore',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '变动华歧系数',
          dataIndex: 'score',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '变动后华歧系数',
          dataIndex: 'afterScore',
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '创建人',
        //   dataIndex: 'creator',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '操作',
        //   dataIndex: 'operation',
        //   width: '18%',
        //   scopedSlots: { customRender: 'operation' },
        //   align: 'center'
        // }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询医生华歧系数变动记录列表 */
    getList () {
      this.loading = true
      this.queryParam.params = {}
      if (this.daterangeCreateTime !== null && this.daterangeCreateTime !== '' && this.daterangeCreateTime.length !== 0) {
        this.queryParam.params['beginCreateTime'] = this.daterangeCreateTime[0]
        this.queryParam.params['endCreateTime'] = this.daterangeCreateTime[1]
      }
     pageDoctorScoreRrecord(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.daterangeCreateTime = []
      this.queryParam = {
        id: undefined,
        doctorName: undefined,
        changeType: undefined,
        beforeScore: undefined,
        score: undefined,
        afterScore: undefined,
        changeScene: undefined,
        creator: undefined,
        modifier: undefined,
        updateTime: undefined,
        isDeleted: undefined,
        remark: undefined,
        version: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delDoctorScoreRrecord(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('doctor/doctorScoreRrecord/export', {
            ...that.queryParam
          }, `医生华歧系数变动记录_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
